module.exports = __webpack_public_path__ + "img/logoIcon.3f8e05e8.png";